module.exports = __webpack_public_path__ + "img/top-banner.7765172a.png";